export function route(uri: string) {
    return '/' + uri.replace(/^\//, '')
}